module.exports = __webpack_public_path__ + "img/JAGUAR.a4b6a13.jpg";